import React from 'react'
import { observer } from 'mobx-react-lite'

import {
  ANALYTICS_EVENTS,
  Loader,
  MicroWidgetContainer,
  useAccountStore,
  useEvent,
  useGlobalCopyStore,
  useGlobalUiStore,
  useNetWorthStore,
  useWidgetLoadTimer,
} from '../common'

import NetworthData from './components/micro/NetworthData'
import ZeroState from './components/micro/ZeroState'

interface NetWorthMicroWidgetProps {
  onCTAClick: () => void
}

export const NetWorthMicroWidget = observer(({ onCTAClick }: NetWorthMicroWidgetProps) => {
  const { visibleAccounts: accounts } = useAccountStore()
  const { onEvent } = useEvent()
  const { net_worth: copy, common: commonCopy } = useGlobalCopyStore()
  const { isInitialized } = useGlobalUiStore()
  const { isNetWorthDataLoaded, loadNetWorthData, netWorthData, selectedData } = useNetWorthStore()

  React.useEffect(() => {
    if (!isNetWorthDataLoaded) {
      loadNetWorthData().finally()
    }
  }, [])

  useWidgetLoadTimer({
    widgetName: 'NetWorthMicroWidget',
    isLoaded: isNetWorthDataLoaded,
  })

  React.useEffect(() => {
    if (isNetWorthDataLoaded) {
      onEvent(ANALYTICS_EVENTS.NET_WORTH_LOAD_WIDGET, {
        state: !accounts?.length ? 'zeroState' : 'default',
      })
    }
  }, [isNetWorthDataLoaded])

  if (!isInitialized || !isNetWorthDataLoaded) return <Loader height={100} />

  const handleCTAClick = () => {
    onEvent(
      !accounts.length
        ? ANALYTICS_EVENTS.NET_WORTH_CLICK_GET_STARTED
        : ANALYTICS_EVENTS.NET_WORTH_CLICK_VIEW_DETAILS,
    )
    onCTAClick()
  }

  return (
    <MicroWidgetContainer
      className="mx-networth-microwidget"
      ctaLabel={commonCopy.see_details}
      onCTAClick={handleCTAClick}
      title={copy.net_worth}
    >
      {netWorthData.accounts.length ? (
        <NetworthData
          amount={selectedData?.y as number}
          copy={copy}
          trendValue={selectedData?.change as number}
        />
      ) : (
        <ZeroState copy={copy} />
      )}
    </MicroWidgetContainer>
  )
})
